module.exports = __webpack_public_path__ + "img/MGH-Gaien-6-2440x1172.6a4a6f9f.jpg";